<template>
  <div class="com-container1">
    <div class="swiper-wrapper commonBoder">
      <el-carousel :interval="10000" type="card" indicator-position="none">
        <el-carousel-item v-for="(item, index) in swiperList" :key="index">
          <img :src="item.url" alt="" srcset="" />
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
import swiper1 from '../assets/images/swiper1.png'
import swiper2 from '../assets/images/swiper2.png'
import swiper3 from '../assets/images/swiper3.png'
import swiper4 from '../assets/images/swiper4.png'
import swiper5 from '../assets/images/swiper5.png'
import swiper6 from '../assets/images/swiper6.png'
import swiper7 from '../assets/images/swiper7.png'
import swiper8 from '../assets/images/swiper8.png'
import swiper9 from '../assets/images/swiper9.png'
import swiper10 from '../assets/images/swiper10.png'
import swiper11 from '../assets/images/swiper11.png'
export default {
  data() {
    return {
      swiperList: [
        { name: '', url: swiper1 },
        { name: '', url: swiper2 },
        { name: '', url: swiper3 },
        { name: '', url: swiper4 },
        { name: '', url: swiper5 },
        { name: '', url: swiper6 },
        { name: '', url: swiper7 },
        { name: '', url: swiper8 },
        { name: '', url: swiper9 },
        { name: '', url: swiper10 },
        { name: '', url: swiper11 }
      ]
    }
  },
  mounted() {

  },
  methods: {}
}
</script>
<style lang="less">
.swiper-wrapper {
  position: relative;
  box-sizing: border-box;
  width: 100%;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    border-radius: 8px;
  }
}

.com-container1 {
  .el-carousel__container {
    height: 220px !important;
  }

  .el-carousel__item--card.is-in-stage {
    height: 135px !important;
    width: 220px !important;
    margin-top: 40px;
  }

  .el-carousel__item--card.is-active {
    height: 210px !important;
    width: 340px !important;
    transform: translate(60px, 10px) !important;
    margin-top: 0;
  }
}
</style>
<style lang="less" scoped>
.com-container1 {
  margin-left:20px
}
</style>
